import type { WallId } from "@gooner/shared";
import { WALL_DEFS } from "@gooner/shared";
import { GoldChip } from "../control/ui/Gold";
import { cx } from "../control/ui/primitives";

/**
 * A wall's mark, the one spelling every surface uses: the Community Wall's brick, and for
 * the Premium Wall the REAL Premium chip — the yellow badge with the white crown that
 * already means "Premium" on names, collections and the share cards — rather than an
 * emoji standing in for it. `WallDef.icon` stays a string for the places that can only
 * carry text (a View's icon, a Discord title); this is what a React surface renders.
 *
 * Decorative here — the wall's NAME sits beside it wherever this appears, so the chip's
 * own "GoonLords Premium" title would only make a row read "GoonLords Premium Premium
 * Wall" to a screen reader. `aria-hidden`, the same as the emoji span it replaces.
 *
 * `size="lg"` is the landing page's hero glyph: the chip is scaled rather than rebuilt,
 * so it stays the one chip (the crown is an SVG and survives the transform crisp).
 */
export function WallGlyph({
  wallId,
  size = "sm",
  className,
}: {
  wallId: WallId;
  size?: "sm" | "lg";
  className?: string;
}) {
  const def = WALL_DEFS[wallId];
  return (
    <span
      aria-hidden
      className={cx("inline-flex items-center justify-center", size === "lg" ? "h-10 text-3xl" : "", className)}
    >
      {def.premiumOnly ? <GoldChip className={size === "lg" ? "scale-[1.9]" : undefined} /> : def.icon}
    </span>
  );
}
